
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    level: 'Level',
    toNextLevel: 'To Next Level',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: 'Deposit {{amount}} coins',
    historyTitle: 'XP History',
    howItWorksTitle: 'How It Works',
    howItWorksFeature1: '{{maxLevel}} levels to unlock',
    howItWorksFeature2: 'Each level requires more XP',
    howItWorksFeature3: 'Complete tasks and stay active to earn XP',
    howItWorksFeature4: 'Get exclusive rewards and take part in activities',
    keyLevels: 'Key Levels',
    xpSourcesTitle: 'How to Earn XP',
    tabActivity: 'Activity',
    tabGameplay: 'Gameplay',
    tabSocial: 'Social',
    rewardsDailyLogin: 'Daily Login',
    rewardsWeeklyStreak: '7-Day Streak',
    rewardsContract: 'Contract Creation',
    rewardsUpgradeSuccess: 'Successful Upgrade',
    rewardsUpgradeFail: 'Failed Upgrade',
    rewardsDrawParticipation: 'Draw Participation',
    rewardsDrawWin: 'Reward from activity',
    rewardsReferralInvite: 'Friend Invitation',
    rewardsReferralDeposit: 'Referral Deposit',
    rewardsCaseBattleWin: 'Case Battle Win',
    rewardsCaseBattleLose: 'Case Battle Loss',
    caseGroupsCheap: 'Cheap Cases',
    caseGroupsMedium: 'Medium Cases',
    caseGroupsExpensive: 'Expensive Cases',
    faqTitle: 'FAQ',
    faqQ1: 'What gives the most XP?',
    faqA1: 'Most XP comes from: opening expensive cases, deposits, draw wins, and inviting active referrals.',
    faqQ2: 'Can I lose my level?',
    faqA2: 'No, your level never drops. XP may be deducted for inactivity, but your achieved level stays with you.',
    faqQ3: 'How to level up faster?',
    faqA3: 'Combine: daily logins, case opening, deposits, inviting friends, and draw participation.',
    faqQ4: 'What does level affect?',
    faqA4: 'Levels give various bonuses: one-time rewards for reaching new levels, permanent privileges, and access to exclusive activities.',
  },
  ru: {
    level: 'Уровень',
    toNextLevel: 'До следующего уровня',
    creditsAbbrevK: 'К',
    creditsAbbrevM: 'М',
    deposit: 'Пополнение {{amount}} монет',
    historyTitle: 'История начислений',
    howItWorksTitle: 'Как работает система',
    howItWorksFeature1: '{{maxLevel}} уровней для прокачки',
    howItWorksFeature2: 'Каждый следующий уровень требует больше XP',
    howItWorksFeature3: 'Выполняй задания и проявляй активность для получения XP',
    howItWorksFeature4: 'Получай эксклюзивные награды за достижения и участвуй в активностях',
    keyLevels: 'Ключевые уровни',
    xpSourcesTitle: 'За что начисляется XP',
    tabActivity: 'Активность',
    tabGameplay: 'Геймплей',
    tabSocial: 'Социалка',
    rewardsDailyLogin: 'Ежедневный вход',
    rewardsWeeklyStreak: 'Серия входов 7 дней',
    rewardsContract: 'Создание контракта',
    rewardsUpgradeSuccess: 'Успешный апгрейд',
    rewardsUpgradeFail: 'Неудачный апгрейд',
    rewardsDrawParticipation: 'Участие в розыгрыше',
    rewardsDrawWin: 'Получение награды в активности',
    rewardsReferralInvite: 'Приглашение друга',
    rewardsReferralDeposit: 'Депозит реферала',
    rewardsCaseBattleWin: 'Победа в кейс баттле',
    rewardsCaseBattleLose: 'Проигрыш в кейс баттле',
    caseGroupsCheap: 'Дешевые кейсы',
    caseGroupsMedium: 'Средние кейсы',
    caseGroupsExpensive: 'Дорогие кейсы',
    faqTitle: 'Частые вопросы',
    faqQ1: 'Что даёт больше всего XP?',
    faqA1: 'Больше всего XP приносят: открытие дорогих кейсов, пополнения, победы в розыгрышах и приглашение активных рефералов.',
    faqQ2: 'Могу ли я потерять уровень?',
    faqA2: 'Нет, твой уровень никогда не понижается. XP может списываться за неактивность, но достигнутый уровень остается с тобой.',
    faqQ3: 'Как быстрее повысить уровень?',
    faqA3: 'Комбинируй: ежедневный вход, открытие кейсов, пополнения, приглашение друзей и участие в розыгрышах.',
    faqQ4: 'На что влияет уровень?',
    faqA4: 'Уровни дают различные бонусы: разовые награды за достижение новых уровней, постоянные привилегии и доступ к эксклюзивным активностям.',
  },
  uz: {
    level: 'Daraja',
    toNextLevel: 'Keyingi darajagacha',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: '{{amount}} tanga depozit',
    historyTitle: 'XP tarixi',
    howItWorksTitle: 'Qanday ishlaydi',
    howItWorksFeature1: '{{maxLevel}} darajani ochish mumkin',
    howItWorksFeature2: 'Har bir keyingi daraja ko\'proq XP talab qiladi',
    howItWorksFeature3: 'Vazifalarni bajaring va XP olish uchun faol bo\'ling',
    howItWorksFeature4: 'Eksklyuziv mukofotlar oling va faolliklarda qatnashing',
    keyLevels: 'Asosiy darajalar',
    xpSourcesTitle: 'XP qanday olish mumkin',
    tabActivity: 'Faoliyat',
    tabGameplay: 'O\'yin',
    tabSocial: 'Ijtimoiy',
    rewardsDailyLogin: 'Kunlik kirish',
    rewardsWeeklyStreak: '7 kunlik ketma-ketlik',
    rewardsContract: 'Kontrakt yaratish',
    rewardsUpgradeSuccess: 'Muvaffaqiyatli apgreyd',
    rewardsUpgradeFail: 'Muvaffaqiyatsiz apgreyd',
    rewardsDrawParticipation: 'Qurada qatnashish',
    rewardsDrawWin: 'Faollikda mukofot olish',
    rewardsReferralInvite: 'Do\'stni taklif qilish',
    rewardsReferralDeposit: 'Referal depoziti',
    rewardsCaseBattleWin: 'Keys jangida g\'alaba',
    rewardsCaseBattleLose: 'Keys jangida mag\'lubiyat',
    caseGroupsCheap: 'Arzon keyslar',
    caseGroupsMedium: 'O\'rtacha keyslar',
    caseGroupsExpensive: 'Qimmat keyslar',
    faqTitle: 'Ko\'p so\'raladigan savollar',
    faqQ1: 'Eng ko\'p XP nima beradi?',
    faqA1: 'Eng ko\'p XP: qimmat keyslar ochish, depozitlar, qura g\'alabalari va faol referallarni taklif qilishdan keladi.',
    faqQ2: 'Darajamni yo\'qotishim mumkinmi?',
    faqA2: 'Yo\'q, darajangiz hech qachon tushmaydi. Faolsizlik uchun XP ayirilishi mumkin, lekin erishilgan daraja siz bilan qoladi.',
    faqQ3: 'Qanday tezroq daraja oshirish mumkin?',
    faqA3: 'Birlashtiring: kunlik kirish, keyslar ochish, depozitlar, do\'stlarni taklif qilish va quralarda qatnashish.',
    faqQ4: 'Daraja nimaga ta\'sir qiladi?',
    faqA4: 'Darajalar turli bonuslar beradi: yangi darajaga erishganda bir martalik mukofotlar, doimiy imtiyozlar va eksklyuziv faolliklarda qatnashish.',
  },
});
